import { storage } from '../../lib/storage'
import { supabase } from '../../lib/supabase'

// ─── Cache pick live con TTL 5 minuti ────────────────────────────────
const PICK_TTL = 5 * 60 * 1000

export async function pickCacheGet(key) {
  try {
    const raw = await storage.get(key)
    if (!raw) return null
    const { ts, data } = JSON.parse(raw)
    if (Date.now() - ts > PICK_TTL) { await storage.remove(key); return null }
    return data
  } catch { return null }
}

export async function pickCacheSet(key, data) {
  try { await storage.set(key, JSON.stringify({ ts: Date.now(), data })) } catch {}
}

// ─── Draft pick (bozza temporanea) ───────────────────────────────────
// Doppio salvataggio: locale (veloce, offline) + DB (safety net per autopick)
const DRAFT_KEY = (userId, stageId, leagueId) => `pick_draft_${userId}_${stageId}_${leagueId}`

export async function draftSave(userId, stageId, leagueId, selected, raceId) {
  try {
    if (!userId || !stageId || !leagueId) return
    if (selected.length === 0) {
      await storage.remove(DRAFT_KEY(userId, stageId, leagueId))
      // Pulisce anche il DB
      await supabase.from('fact_user_draft')
        .delete()
        .eq('id_user', userId)
        .eq('id_stage', stageId)
        .eq('id_league', leagueId)
    } else {
      // Salva in locale
      await storage.set(DRAFT_KEY(userId, stageId, leagueId), JSON.stringify(selected))
      // Salva su DB solo se abbiamo raceId
      if (!raceId) return
      const rows = selected.map((r, i) => ({
        id_user:   userId,
        id_stage:  stageId,
        id_league: leagueId,
        id_race:   raceId,
        id_rider:  r.value,
        id_team:   r.id_team,
        id_slot:   i + 1,
      }))
      // Prima cancella i vecchi slot (potrebbero essere cambiati)
      await supabase.from('fact_user_draft')
        .delete()
        .eq('id_user', userId)
        .eq('id_stage', stageId)
        .eq('id_league', leagueId)
      // Poi inserisce i nuovi
      await supabase.from('fact_user_draft').insert(rows)
    }
  } catch {}
}

export async function draftLoad(userId, stageId, leagueId) {
  try {
    // Prima prova in locale (più veloce)
    const raw = await storage.get(DRAFT_KEY(userId, stageId, leagueId))
    if (raw) return JSON.parse(raw)
    // Fallback su DB (es. utente ha cambiato device)
    const { data } = await supabase.from('fact_user_draft')
      .select('id_rider, id_team, id_slot')
      .eq('id_user', userId)
      .eq('id_stage', stageId)
      .eq('id_league', leagueId)
      .order('id_slot')
    if (!data || data.length === 0) return null
    // Ricostruisce il formato compatibile con selected
    return data.map(d => ({ value: d.id_rider, id_team: d.id_team }))
  } catch { return null }
}

export async function draftClear(userId, stageId, leagueId) {
  try {
    await storage.remove(DRAFT_KEY(userId, stageId, leagueId))
    await supabase.from('fact_user_draft')
      .delete()
      .eq('id_user', userId)
      .eq('id_stage', stageId)
      .eq('id_league', leagueId)
  } catch {}
}